
import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { User, SetUser } from './Hooks/Logged';
import { Carrito, SetCarrito } from './Hooks/Carrito';
import axios from 'axios'
import Routes from './Routes';
import { ConfigProvider, theme } from 'antd';
import { CookiesProvider } from 'react-cookie';

axios.defaults.baseURL = process.env.REACT_APP_WEB_SERVICE
axios.defaults.withCredentials = true
axios.defaults.headers.common["Content-Type"] = "application/json";

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  if (response?.headers?.authorization) {
    sessionStorage.setItem("token", response?.headers?.authorization)
  }
  return response
}, function (error) {
  return Promise.reject(error);
})

axios.interceptors.request.use(function (config) {
  config.headers.Authorization = sessionStorage.getItem("token")
  return config;
})



/**
 * 
 * @class App
 * @extends {Component}
 */
class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      user: 0,
      carrito: {},
      // socket: createSocket()
    }
  }

  componentDidMount() {
    axios.get('/user/logged', {
      headers: { Authorization: sessionStorage.getItem('token') }
    }).then(({ data }) => {
      this.setUser(data.data)
      this.getCarrito()
    }).catch((error) => {
      console.log('error', error.response)
    })
  }

  setUser = (user) => this.setState({ user })

  setCarrito = (carrito) => this.setState({ carrito })

  getCarrito = () => {
    axios.get("/carrito")
    .then(({data}) => {
      this.setCarrito(data)
    }).catch(error => {
      console.error("error al obtener el carrito de compra")      
    })
  }

  render() {
    const { setUser, setCarrito } = this;
    const { user, socket, carrito } = this.state;
    return (
      <ConfigProvider
        theme={{
          colorPrimary: 'red',
          token: {
            algorithm: theme.darkAlgorithm,
            fontFamily: "Roboto",
            colorPrimary: '#EE492A',
          },
        }}
      >
        <BrowserRouter>
          <CookiesProvider>
            <Carrito.Provider value={carrito}>
              <SetCarrito.Provider value={setCarrito}>
                <User.Provider value={user}>
                  <SetUser.Provider value={setUser}>
                    <Routes />
                  </SetUser.Provider>
                </User.Provider>
              </SetCarrito.Provider>
            </Carrito.Provider>
          </CookiesProvider>
        </BrowserRouter>
      </ConfigProvider >
    )
  }
}

export default function (props) {

  return <App {...props} />

}